import { z } from "zod";
import { OffboardingAnswerSchema } from "./offboarding-questionnaire.schema.ts";
import { OffboardingRequestSchema } from "./offboarding-request.schema.ts";

export const OffboardingDetailSchema = z.object({
    offboarding: OffboardingRequestSchema,
    retentionAnswers: z.array(OffboardingAnswerSchema).nullable(),
    resignationAnswers: z.array(OffboardingAnswerSchema).nullable(),
    exitInterviewAnswers: z.array(OffboardingAnswerSchema).nullable(),
    itAnswers: z.array(OffboardingAnswerSchema).nullable(),
    hrAnswers: z.array(OffboardingAnswerSchema).nullable(),
    payrollAnswers: z.array(OffboardingAnswerSchema).nullable(),
    adminAnswers: z.array(OffboardingAnswerSchema).nullable(),
    rmAnswers: z.array(OffboardingAnswerSchema).nullable(),
});

export type OffboardingDetail = z.infer<typeof OffboardingDetailSchema>;
